import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
    LayoutDashboard,
    Package,
    ArrowLeftRight,
    Tags,
    Wallet,
    KeyRound,
    Users,
    Building2,
    LogOut,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const NAV = [
    { to: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, testid: "nav-dashboard" },
    { to: "/inventory", label: "Inventaire", icon: Package, testid: "nav-inventory" },
    { to: "/transactions", label: "Transactions", icon: ArrowLeftRight, testid: "nav-transactions" },
    { to: "/vault", label: "Coffre", icon: Wallet, testid: "nav-vault" },
    { to: "/rentals", label: "Locations", icon: KeyRound, testid: "nav-rentals" },
    { to: "/persons", label: "Personnes", icon: Users, testid: "nav-persons" },
    { to: "/organizations", label: "Organisations", icon: Building2, testid: "nav-organizations" },
    { to: "/categories", label: "Catégories", icon: Tags, testid: "nav-categories" },
];

export default function Layout() {
    const { logout } = useAuth();
    const nav = useNavigate();

    const doLogout = () => {
        logout();
        toast.success("Déconnexion");
        nav("/");
    };

    return (
        <div className="min-h-screen bg-[#F7F3E8] flex">
            <aside className="w-64 shrink-0 bg-[#2E3A22] text-[#EDE7D3] flex flex-col h-screen sticky top-0">
                <div className="px-6 py-7 border-b border-[#3D4E2E]">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#C8A75C] font-semibold">
                        Gestion du stock
                    </div>
                    <div className="font-mc text-2xl font-semibold tracking-tight mt-1">
                        Raza Perdida MC
                    </div>
                </div>
                <nav className="flex-1 px-3 py-6 space-y-1">
                    {NAV.map(({ to, label, icon: Icon, testid }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={to === "/dashboard"}
                            data-testid={testid}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-150 ${
                                    isActive
                                        ? "bg-[#F5EFDA] text-[#2E3A22]"
                                        : "text-[#D9D3B8] hover:bg-[#3D4E2E] hover:text-white"
                                }`
                            }
                        >
                            <Icon className="w-4 h-4" />
                            {label}
                        </NavLink>
                    ))}
                </nav>
                <div className="px-3 py-4 border-t border-[#3D4E2E]">
                    <Button
                        variant="ghost"
                        data-testid="logout-btn"
                        onClick={doLogout}
                        className="w-full justify-start text-[#D9D3B8] hover:bg-[#3D4E2E] hover:text-white"
                    >
                        <LogOut className="w-4 h-4 mr-2" />
                        Se déconnecter
                    </Button>
                </div>
            </aside>
            <main className="flex-1 min-w-0">
                <Outlet />
            </main>
        </div>
    );
}
